import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f5f4f644")

_pushScopeId("data-v-f5f4f644")
const _hoisted_1 = { class: "headTip" }
const _hoisted_2 = { class: "topText" }
const _hoisted_3 = { class: "topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "topText_xny"
}
const _hoisted_7 = { class: "ptb5" }
const _hoisted_8 = {
  key: 0,
  class: "productname_wrapper productname_bg productname_bg_699"
}
const _hoisted_9 = { class: "topText_small" }
const _hoisted_10 = { class: "topText_small" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "topText_small_shallow" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_12 = { class: "banner_cheKuang_main" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.getData('brandLogo'))
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.getData('brandLogo'),
                  class: "topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getData('brandName')), 1),
          (_ctx.getData('energyType') === '2')
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.getData('detectItem'))
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("span", {
                    class: "productname_font productname productname_699",
                    text: _ctx.getData('detectItem')
                  }, _toDisplayString(_ctx.getData("detectItem")), 9, ["text"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.getData("modelName")), 1),
        _createVNode("div", _hoisted_10, "VIN: " + _toDisplayString(_ctx.getData("VIN")), 1),
        _hoisted_11
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("img", {
          src: require('../../../../../assets/promiseFrame/tipIcon.png')
        }, null, 8, ["src"]),
        _createTextVNode(" " + _toDisplayString(_ctx.getData('checkInstructionsH5')), 1)
      ])
    ])
  ]))
})